import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useSettingsStore = create(
  persist(
    (set) => ({
      episodeSortAsc: true,

      setEpisodeSortAsc: (value) => set({ episodeSortAsc: value }),
      toggleEpisodeSort: () => set((state) => ({ episodeSortAsc: !state.episodeSortAsc })),
    }),
    {
      name: 'settings-storage',
    }
  )
);

export default useSettingsStore;
